import React from 'react';
import IconWithHover from "../IconWithHover/IconWithHover";

/**
 * An info button that stays open as long as you hover over it. On mobile,
 * it will open on click and close when clicked outside.
 * @param {{ title: Object, text: Object }} infoContent - The content to display in popover as an object composed of a title and text field.
 * @param {number} [hoverDuration=500] - Duration (in ms) to delay before closing the popover.
 * @constructor
 */
export default function InfoButton({ infoContent, hoverDuration = 500 }) {
    return <IconWithHover hoverDuration={hoverDuration} popoverContent={infoContent}/>
}